// Colores centralizados por entorno
// Todos los componentes React deben importar de aquí para mantener consistencia
import config from '../config';

const env = config.REACT_APP_DEPLOYMENT || 'local';

const palettes = {
  local: {
    primary: '#059669',
    primaryDark: '#047857',
    primaryLight: '#ecfdf5',
    primaryFaint: '#f0fdf4',
  },
  dev: {
    primary: '#dc2626',
    primaryDark: '#b91c1c',
    primaryLight: '#fef2f2',
    primaryFaint: '#fff1f2',
  },
  test: {
    primary: '#dc2626',
    primaryDark: '#b91c1c',
    primaryLight: '#fef2f2',
    primaryFaint: '#fff1f2',
  },
  prod: {
    primary: '#2563eb',
    primaryDark: '#1d4ed8',
    primaryLight: '#eff6ff',
    primaryFaint: '#eff6ff',
  },
  production: {
    primary: '#2563eb',
    primaryDark: '#1d4ed8',
    primaryLight: '#eff6ff',
    primaryFaint: '#eff6ff',
  },
};

const palette = palettes[env] || palettes.local;

const colors = {
  // Primario (varía por entorno)
  primary: palette.primary,
  primaryDark: palette.primaryDark,
  primaryLight: palette.primaryLight,
  primaryFaint: palette.primaryFaint,

  // Secundarios (fijos)
  success: '#059669',
  successDark: '#047857',
  danger: '#dc2626',
  dangerDark: '#b91c1c',
  dangerLight: '#fef2f2',
  warning: '#f59e0b',
  warningDark: '#d97706',
  info: '#0ea5e9',
  infoDark: '#0284c7',

  // Neutrales
  text: '#111827',
  textSecondary: '#6b7280',
  textMuted: '#9ca3af',
  border: '#e5e7eb',
  borderStrong: '#d1d5db',
  bg: '#f9fafb',
  bgCard: '#ffffff',
};

export default colors;
